import { Field, Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { OfferionErrorMessage } from '../../../forms/validation/OfferionErrorMessage'
import Modal from '../../../modal'
import { useOfferionTranslation } from '../../../store/hooks/useOfferionTranslation'
import { validateIban } from '../../../utils/validators'

interface IbanModalProps {
    isOpen: boolean
    initialIban?: string
    onClose: () => void
    onSubmit: (iban: string) => Promise<void> | void
}

export const IbanModal = ({ isOpen, initialIban = '', onClose, onSubmit }: IbanModalProps) => {
    const { t } = useOfferionTranslation()

    const validationSchema = Yup.object({
        iban: Yup.string()
            .required(
                t('Allaround.Validation.required', {
                    fieldName: t('Settings.Table.Contact.iban'),
                })
            )
            .test('valid-iban', t('V2.Onboarding.Step2.ibanInvalidFormat'), value => {
                return !value || validateIban(value)
            }),
    })

    return (
        <Modal isOpen={isOpen}>
            <div className="popup__overlay popup__overlay--show">
                <div className="popup">
                    <h1 className="overlay__title">{t('Settings.Table.Contact.iban')}</h1>

                    <div className="popup__close icono-cross" onClick={onClose}>
                        {t('Allaround.Popup.close')}
                    </div>

                    <Formik
                        initialValues={{ iban: initialIban }}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={true}
                        enableReinitialize
                        onSubmit={async ({ iban }) => {
                            const cleanedUpIban = iban.replace(/\s+/g, '').toUpperCase()
                            await onSubmit(cleanedUpIban)
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form noValidate>
                                <div className="address-placeholder">
                                    <div className="info__row w-full">
                                        <label htmlFor="iban" className="leading-normal">
                                            {t('Settings.PrintSettings.Table.Invoice.PrintPaymentCode.Message.invalidIBAN')}
                                        </label>

                                        <div className="info__row-content">
                                            <Field
                                                id="iban"
                                                name="iban"
                                                type="text"
                                                autoComplete="off"
                                                placeholder={t('V2.Onboarding.Step2.ibanPlaceholder')}
                                            />
                                            <OfferionErrorMessage name="iban" />
                                        </div>
                                    </div>
                                </div>

                                <div className="popup__buttons mt-4">
                                    <button className="button button--gray popup__button" type="button" onClick={onClose}>
                                        <span className="icon icon--small icon__cross-red" />
                                        <span className="button-text button-text--always-show">{t('Allaround.Button.cancel')}</span>
                                    </button>

                                    <button className="button button--gray popup__button" type="submit" disabled={isSubmitting}>
                                        <span className="icon icon__check-green" />
                                        <span className="button-text button-text--always-show">{t('Allaround.Button.save')}</span>
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    )
}
